<template>
<div class="chapter">
<div class="inner_page">
<p class="half"><span epub:type="pagebreak" id="pagei" title="i"><img alt="Illustration" src="images/f000i-01.png"/></span></p>
<div class="page-break">
<p class="image1"><span epub:type="pagebreak" id="pageii" title="ii"><img alt="Illustration" src="images/f00ii-01.jpg"/><a id="fig1"></a></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// half.vue?1e9e2b2e